export default class DeleteCategoryMappingRequest {
    public reportDefinitionId: string = "";
    
    public productGroupId: string | null = null;
    
    public productType: string | null = null;
}